import { render, staticRenderFns } from "./CertUpload.vue?vue&type=template&id=2afc523c&scoped=true"
import script from "./CertUpload.vue?vue&type=script&lang=js"
export * from "./CertUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afc523c",
  null
  
)

export default component.exports